import PersonPackages from '../components/Person/PersonPackages/PersonPackages';
import PersonPackage from '../components/Person/PersonPackage/PersonPackage';
import LoanOrders from "../components/Loan/Order/LoanOrders";
import LoanOrderInfo from "../components/Loan/Order/LoanOrderInfo";
import LoanOrderCreation from "../components/Loan/Order/LoanOrderCreation";
import SummaryStat from "../components/Statistics/SummaryStat/SummaryStat";
import TrackGeoActivity from "../components/Statistics/GeoActivity/TrackGeoActivity";
import GeoActivity from "../components/Statistics/GeoActivity/GeoActivity";

const UserRoutes = [
	{
		collapse: false,
		path: "/",
		name: {
			"ru": "Главная",
			"en": "Main",
			"sk": "Hlavná"
		},
		state: "home",
		icon: "mdi mdi-home",
	},
	{
		collapse: false,
		path: "/dashboard/geoActivity/track",
		name: {
			"ru": "Check-in/out",
            "en": "Check-in/out",
            "sk": "Check-in/out",
		},
		state: "check-in-out",
		icon: "mdi mdi-qrcode-scan",
		component: TrackGeoActivity,
		companyAttribute: "AllowGeoActivity",
	},
	{
		path: "/dashboard/statistics/geoActivity",
		name: {
			"ru": "Geo активность",
			"en": "Geo activity",
			"sk": "Geo activity"
		},
		mini: "B",
		icon: "mdi mdi-map-marker-radius",
		component: GeoActivity,
		companyAttribute: "AllowGeoActivity",
	},
	{
		collapse: false,
		path: "/dashboard/person/packages",
		name: {
			"ru": "Пакеты",
			"en": "Packages",
			"sk": "Balíčky"
		},
		state: "packages",
		icon: "mdi mdi-book-multiple",
		component: PersonPackages,
		// child: [
		// 	{
		// 		path: "/market",
		// 		name: "Маркет",
		// 		mini: "B",
		// 		icon: "mdi mdi-apps",
		// 		component: Market
		// 	},
		// 	{
		// 		path: "/market/add",
		// 		name: "Загрузка приложения",
		// 		mini: "B",
		// 		icon: "mdi mdi-upload",
		// 		component: UploadApk
		// 	},
		// 	{
		// 		path: "/market/app",
		// 		name: "Настройка приложения",
		// 		mini: "B",
		// 		icon: "mdi mdi-border-color",
		// 		component: Apk
		// 	},
		// ]
	},
	{
		collapse: false,
		path: "/dashboard/loan/orders",
		name: {
			"ru": "Кредиты",
			"en": "Loans",
			"sk": "Úver"
		},
		state: "loan-orders",
		icon: "mdi mdi-credit-card",
		component: LoanOrders,
	},
	{
		collapse: false,
		path: "/dashboard/statistics/general",
		name: {
			"ru": "Общий отчет",
			"en": "General report",
			"sk": "Všeobecná správa"
		},
		state: "statistics-general",
		icon: "mdi mdi-format-list-bulleted",
		component: SummaryStat
	},
	{
        collapse: false,
		path: "/chat",
		isLink: true,
        name: {
            "ru": "Поддержка",
            "en": "Support",
            "sk": "Podpora"
        },
        state: "chat",
        icon: "mdi mdi-comment-multiple-outline"
    },
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/person/packages/:packageId",
		state: "offer",
		component: PersonPackage,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/loan/order/info/:orderId",
		state: "loan-order",
		component: LoanOrderInfo,
	},
	{
		invisible: true,
		collapse: false,
		path: "/dashboard/loan/order/create",
		state: "loan-order-creation",
		component: LoanOrderCreation,
	},

];
export default UserRoutes;



// WEBPACK FOOTER //
// ./src/routes/userRoutes.js